import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("video", { autoplay: "" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_sidebar_menu_item = _resolveComponent("app-sidebar-menu-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_app_sidebar_menu_item, {
      label: "Техподдержка",
      icon: "megaphone_light",
      "is-collapsed": _ctx.isCollapsed,
      "is-disabled": _ctx.isLoading,
      type: "div",
      onExpand: _ctx.relocate
    }, null, 8, ["is-collapsed", "is-disabled", "onExpand"]),
    _createElementVNode("div", {
      id: "screenBlock",
      class: _normalizeClass(_ctx.$style.screenBlock)
    }, _hoisted_2, 2)
  ]))
}